export default __webpack_public_path__ + "locales/it/Translations.json?hash=ec4c1bd172312ad7226b9b54c75030f0";